// import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/auth";
import { createStore, combineReducers } from "redux";
import registerReducer from "./auth/register";
import selectedPairSlice from "./selectedPair";
import spotSlice from "./spot";
import depositSlice from "./deposit";
import withdrawSlice from "./withdraw";
// export const store = configureStore({
//   reducer: authReducer,
// });

// const reducer = combineReducers({
//   auth: authReducer,
//   register: registerReducer,
// });

import { configureStore } from "@reduxjs/toolkit";
import  selectedNetworkSlice  from "./selectedNetwork";
import  coinList from "./coinList";
//Importing the reducer from countSlice


export const store = configureStore({
  reducer: {
    auth: authReducer,
    register: registerReducer,
    pair: selectedPairSlice,
    spot: spotSlice,
    deposit: depositSlice,
    withdraw: withdrawSlice,
    network: selectedNetworkSlice,
    coinList:coinList
  },
});
// export const store = configureStore({ reducer });
// // Infer the `RootState` and `AppDispatch` types from the store itself
// export type RootState = ReturnType<typeof store.getState>;
// // Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
// export type AppDispatch = typeof store.dispatch;
